import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { KeycloakProvider } from '@y-sports/shared/auth';
import App from './App';
import { initializeI18n } from './i18n/config';
import { tournamentWorkspaceRedirectUri } from './features/tournaments/model/workspaceNavigation';
import './styles/index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

async function bootstrap() {
  await initializeI18n();

  ReactDOM.createRoot(document.getElementById('root')!).render(
    // StrictMode disabled to prevent Keycloak double initialization in dev
    // Re-enable for production builds
    // <React.StrictMode>
      <KeycloakProvider
        url={import.meta.env.VITE_KEYCLOAK_URL}
        realm={import.meta.env.VITE_KEYCLOAK_REALM}
        clientId={import.meta.env.VITE_KEYCLOAK_CLIENT_ID}
        redirectUri={tournamentWorkspaceRedirectUri(window.location)}
      >
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </KeycloakProvider>
    // </React.StrictMode>
  );
}

void bootstrap();
